// Rimuovi l'importazione del CSS originale
// import './TopBarMobile.css';
import './tailwind.css';

export default function TopBarMobile({ nome, cognome, toggleSidebar }) {
  return (
    // Topbar mobile: nascosta su desktop (md:hidden), visibile su mobile (flex)
    // Posizione fissa in alto, z-index abbassato a z-30 per permettere alla sidebar di sovrapporsi
    // padding, sfondo semitrasparente con blur e ombra
    <div className="md:hidden flex fixed top-0 w-full z-30 justify-between items-center px-4 py-3 bg-mioblu shadow-lg backdrop-blur-sm">
      <div className="flex flex-col">
        <small className="text-xs uppercase text-gray-300 mb-0.5 tracking-wide">BUONGIORNO</small>
        <div className="text-base font-medium text-white">{nome} {cognome}</div>
      </div>
      <button
        className="text-2xl bg-transparent border-none text-white cursor-pointer p-2 hover:text-red-600 transition-colors duration-200"
        onClick={toggleSidebar}
      >
        ☰
      </button>
    </div>
  );
}
